export const isEmptyString = (value?: string) => !Boolean(value?.trim().length);
